import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

export const PlusIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <path d="M7 2C7 1.44772 6.55228 1 6 1C5.44772 1 5 1.44772 5 2V5L2 5C1.44771 5 1 5.44771 1 6C1 6.55228 1.44771 7 2 7L5 7V10C5 10.5523 5.44772 11 6 11C6.55228 11 7 10.5523 7 10V7L10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5L7 5V2Z" />
  </SvgIcon>
);
